import useAuth from 'src/careflow/ph-core/authentication/hook/useAuth';

const ICOMX_BLOCKED_ROUTE_SEGMENTS = [
  'select-organization-n-role',
  'select-tenant',
  '/login',
  '/auth/',
] as const;

export interface IcomxAvailability {
  isLoggedIn: boolean;
  hasCompletedLoginSetup: boolean;
}

export function isIcomxBlockedPath(pathname: string) {
  return ICOMX_BLOCKED_ROUTE_SEGMENTS.some((segment) => pathname.includes(segment));
}

export function getIcomxAvailability(params: {
  isInitialized?: boolean;
  isAuthenticated?: boolean;
  user?: unknown;
  pathname?: string;
}): IcomxAvailability {
  const isLoggedIn = !!params.isInitialized && !!params.isAuthenticated && !!params.user;
  const pathname = params.pathname ?? '';
  const hasCompletedLoginSetup = isLoggedIn && !isIcomxBlockedPath(pathname);

  return {
    isLoggedIn,
    hasCompletedLoginSetup,
  };
}

export function useIcomxAvailability() {
  const { isInitialized, isAuthenticated, getCurrentUser } = useAuth();
  const pathname = typeof window === 'undefined' ? '' : window.location.pathname;

  return getIcomxAvailability({
    isInitialized,
    isAuthenticated,
    user: getCurrentUser(),
    pathname,
  });
}